<template>
    <div class="mx-auto">
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Tipo de Receita:"
                        label-for="valor"
                        class="text-label required">
                    <b-form-select v-model="receitaDiversa.receita" 
                    :class="(!obrigatorio ? 'invalid-select' : '')" required>
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.receitas"
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.nome ? tc.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                    <div v-if="!obrigatorio" class="invalid-message">Campo Obrigatório.</div>
                    
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col md="2">
                <b-form-group
                        label="CPF / CNPJ do Cedente:"
                        label-for="cpf"
                        class="text-label required"
                        description="Somente os números" >
                    <b-form-input
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="receitaDiversa.cpfCnpjDevedor"
                            :error-messages="errors.collect('cpf')"
                            :state="errors.has('cpf')==false?null:!errors.has('cpf')"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            description="Somente os números"
                            @change="buscarDevedor"
                            :class="'cpfCnpj ' + (!validations1.cpf.valid ? 'is-invalid' : '') + (!obrigatorio1? 'is-invalid' : '')" 
                     ></b-form-input>
                    <span v-if="!validations1.cpf.valid && validations1.cpf.invalidDocument" class="invalid-message">Documento inválido!</span>
                    <b-row>
                     <b-col sm="12" md="12">
                     <div v-if="!obrigatorio1" class="invalid-message">Campo Obrigatório.</div>
                     </b-col>
                    </b-row> 
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label required" >
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="devedor"
                            v-model="receitaDiversa.nomeDevedor"
                            data-vv-as="devedor"
                            description="Devedor"
                            disabled
                        ></b-form-input>
                        <b-button
                            id="adicionarDevedor"
                            class="icon-button"
                            title="Abrir Cadastro do Devedor"
                            variant="outline-primary"
                            @click="abrirModalDevedor()"
                        >
                            <i class="far fa-address-book fa-flip-horizontal"></i>
                        </b-button>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="2">
                <b-form-group
                        label="Valor (R$):"
                        label-for="valor"
                        class="text-label required">
                    <b-form-input v-model="receitaDiversa.valor" type="text" id="valor"
                                  @change="validarValor"
                                  :class="!validations.valor.valid ? 'is-invalid' : '' + (!obrigatorio2 ? 'is-invalid' : '')"
                                  @keyup="receitaDiversa.valor = formatarMonetario(receitaDiversa.valor)"/>
                     <b-row>
                     <b-col sm="12" md="12">
                     <div v-if="!obrigatorio2" class="invalid-message">Campo Obrigatório.</div>
                     </b-col>
                    </b-row> 
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Forma de Pagamento:"
                        label-for="formapagamento"
                        class="text-label required">
                    <b-form-select v-model="receitaDiversa.formaPagamento" :class="(!obrigatorio4 ? 'invalid-select' : '')" >
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.formasPagamento"
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.nome ? tc.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                    
                     <div v-if="!obrigatorio4" class="invalid-message">Campo Obrigatório.</div>
                    
                </b-form-group>
            </b-col>
            <b-col md="3" v-if="receitaDiversa.formaPagamento === ID_FORMA_PAGAMENTO_TRANSFERENCIA">
                <b-form-group
                        label="Data da Transferência:"
                        label-for="dataTransferencia"
                        class="text-label required">
                    <b-form-input
                        v-model="receitaDiversa.dataTransferencia"
                        id="dataTransferencia"
                        :max="maxDate"
                        name="dataTransferencia"
                        type="date"
                        @blur="validarDataTransferencia"
                        :class="(!obrigatorio5 ? 'is-invalid' : '')"
                    ></b-form-input>
                    <span v-show="errors.has('dataTransferencia')">A data inserida é inválida!</span>
                    <div v-if="!validations.data.pastDate" class="invalid-message">A data inserida é maior que a data atual.</div>
                    <b-row>
                     <b-col sm="12" md="12">
                     <div v-if="!obrigatorio5" class="invalid-message">Campo Obrigatório.</div>
                     </b-col>
                    </b-row> 
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12">
                <div v-if="!validations.valor.valid" class="invalid-message">Não é permitida a emissão de Requisição de valor zero ou negativo.</div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                        label="Observações"
                        label-for="textarea-formatter">
                    <b-form-textarea
                            id="observacoes"
                            v-model="receitaDiversa.observacoes"
                            size="500"
                            placeholder=""
                            max-rows="10"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="5">
                <label for="carregarArq">Anexar arquivo(s):</label>
                <b-form-group id="input-group-1" label="" label-for="parcelamento">
                    <b-form-file id="carregarArq" v-model="arquivos" @input="realizarUpload()"
                                 placeholder="Para selecionar mais de um arquivo : ctrl + clique" multiple
                                 accept="image/png|image/jpeg|image/jpg|text/plain"></b-form-file>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o Setor responsável pela Requisição:"
                        label-for="setor"
                        class="text-label required">
                    <b-form-select v-model="receitaDiversa.setor" class='form-select'
                                 :class="(!obrigatorio3 ? 'invalid-select' : '')">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                            v-for="setor in dados.setores"
                            :key="setor.codSetor"
                            :value="setor.codSetor">
                                {{ setor.nome ? setor.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                    
                     <div v-if="!obrigatorio3" class="invalid-message">Campo Obrigatório.</div>
                    
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-for="arquivo in receitaDiversa.arquivos">
            <b-col md="6" class="mt-1">
                <a class="link" style="margin-left: 30px;" @click="obterAnexo(arquivo)">
                    {{ arquivo.nomeArquivo }}
                </a>
                <b-button class="ml-2"
                        variant="outline-warning"
                        @click="excluirArquivo(arquivo)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </b-col>
        </b-row>

        <CompLoading ref="loading"/>
        <ModalIncluirDevedor
            ref="modalDevedor"
            @novoDevedor="novoDevedor"
            @cancelarNovoDevedor="cancelarNovoDevedor" />
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loading"
                @salvarDevedor="salvarDevedor"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import moment from 'moment'

    export default {
        props: ['receitaDiversa','validations', 'obrigatorio', 'obrigatorio1', 'obrigatorio2', 'obrigatorio3', 'obrigatorio4', 'obrigatorio5'],
        mixins: [ formatarMixins ],
        components: {CompLoading, ModalIncluirDevedor, ModalAlterarDevedor},
        data() {
            return {
                ID_FORMA_PAGAMENTO_TRANSFERENCIA: 2,
                urlApi: null,
                token: null,
                maxDate: null,
                arquivos: [],
                dados: {
                    receitas: [],
                    formasPagamento: [],
                    uf: [],
                    municipios: [],
                    setores: []
                },
                contribuinte: {
                    nome: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: null,
                    municipio: null
                },
                
                validations1: {
                    cpf: {
                        valid: true,
                        invalidDocument: false,
                       
                    },
                    
                },
                
                paymentValidations: {
                    valor: { valid: true, message: ""}
                    
                }, 
                messageModal: null
            }
        },
        created () {
            this.$validator.extend('dateRange', {
                getMessage () {
                    return 'A data inserida é inválida!'
                },
                validate (value) {
                    return moment(value).isValid()
                }
            })
        },
        methods: {
            async listarReceitas() {
                axios.get(`${this.urlApi}/v1/receitasDiversas/listarReceitas`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.receitas = response.data
                })
            },
            async listarFormaPagamento() {
                axios.get(`${this.urlApi}/v1/receitasDiversas/listarFormaPagamento`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.formasPagamento = response.data
                })
            },
            async listarSetores () {
                axios.get(`${this.urlApi}/v1/receitasDiversas/listarSetor`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.setores = response.data
                })
            },
            async buscarDevedor() {
                 this.$store.commit("setMessages", {});
                this.validations1.cpf.valid = true;
                this.validations1.cpf.invalidDocument = false;
                if(this.receitaDiversa.cpfCnpjDevedor.length <= 14 && !this.validarCpf(this.receitaDiversa.cpfCnpjDevedor)) {
                   this.validations1.cpf.valid = false;
                    this.validations1.cpf.invalidDocument = true;
                    this.cancelarNovoDevedor()
                    return;
                } else if(this.receitaDiversa.cpfCnpjDevedor.length > 14 && !this.validarCnpj(this.receitaDiversa.cpfCnpjDevedor)) {
                    this.validations1.cpf.valid = false;
                    this.validations1.cpf.invalidDocument = true;
                    this.cancelarNovoDevedor()
                    return;
                }

                this.receitaDiversa.codDevedor = null;

                let devedor = {
                    documento: this.receitaDiversa.cpfCnpjDevedor
                };

                axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        this.receitaDiversa.codDevedor = response.data.codContribuinte;
                        this.receitaDiversa.nomeDevedor = response.data.nome;
                    } else {
                        this.$refs.modalDevedor.abrirModalIncluirDevedorCpf(this.receitaDiversa.cpfCnpjDevedor);
                    }
                })
            },

            abrirModalDevedor () {
                if (this.receitaDiversa.codDevedor != null) {
                    this.$refs.modalAlterarDevedor.carregarCadastro(this.receitaDiversa.codDevedor)
                } else {
                    this.$refs.modalDevedor.abrirModalDevedor({ modalTitulo: 'Cadastro do Devedor' })
                }
            },

            novoDevedor (contribuinte) {
                this.receitaDiversa.codDevedor = contribuinte.codContribuinte
                this.receitaDiversa.nomeDevedor = contribuinte.nome
                this.receitaDiversa.cpfCnpjDevedor = contribuinte.documento
            },

            salvarDevedor (devedorSalvo) {
                this.receitaDiversa.codDevedor = devedorSalvo.codContribuinte
                this.receitaDiversa.nomeDevedor = devedorSalvo.nome
                this.receitaDiversa.cpfCnpjDevedor = devedorSalvo.documento
            },

            cancelarNovoDevedor () {
                this.receitaDiversa.codDevedor = null
                this.receitaDiversa.cpfCnpjDevedor = null
                this.receitaDiversa.nomeDevedor = null
            },

            realizarUpload() {
                this.$store.commit("setMessages", {});
                let arquivosConvertidos = {}
                this.arquivos.forEach(file => {
                    /* if (!file.name.endsWith(".jpeg")
                        && !file.name.endsWith(".jpg")
                        && !file.name.endsWith(".png")
                        && !file.name.endsWith(".pdf")) {
                        this.exibirMensagem("Formato do arquivo inválido.")
                    } else */ if ((file.size / 1024) / 1024 > 50.0) {
                        this.exibirMensagem("O tamanho do arquivo ultrapassa o limite permitido pelo sistema (50Mb)!")
                    } else {
                        var reader = new FileReader()
                        reader.onload = function (e) {
                            let arquivo = {
                                nomeArquivo: file.name,
                                base64: e.target.result
                            }
                            arquivosConvertidos[file.name] = arquivo
                        }
                        reader.readAsDataURL(file)
                        reader.onloadend = () => this.executeUpload(arquivosConvertidos[file.name])
                    }
                })
            },
            executeUpload (arquivoConvertido) {
                this.receitaDiversa.arquivos.push(arquivoConvertido)
                this.arquivos = []
            },

            excluirArquivo (arquivo) {
                const index = this.receitaDiversa.arquivos.indexOf(arquivo)
                this.receitaDiversa.arquivos.splice(index, 1)
            },
            validarDataTransferencia () {
                this.obrigatorio5 = true;
                this.$validator.validateAll()
                if(this.verificarValorVazio(this.receitaDiversa.dataTransferencia)) {
                    this.obrigatorio5 = false;
                } else if(!this.verificarValorVazio(this.receitaDiversa.dataTransferencia) &&
                    new Date(this.receitaDiversa.dataTransferencia) > new Date()) {
                    this.validations.data.pastDate = false;
                } else {
                    this.validations.data.pastDate = true;
                }
            },
            verificarObrigatoriedade() {
                return !(this.verificarValorVazio(this.contribuinte.nome) ||
                    this.verificarValorVazio(this.contribuinte.documento));
            },
            validarValor() {
                let valor = this.tratarCamposNumericos(this.receitaDiversa.valor)
                if(valor <= 0) {
                    this.$emit('alterarValidadeValor', false);
                } else {
                    this.$emit('alterarValidadeValor', true);
                }
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.listarReceitas();
            this.listarFormaPagamento();
            this.listarSetores()

            var dataAtual = new Date();
            let ano = dataAtual.getFullYear();
            let mes = dataAtual.getMonth() + 1;
            this.maxDate = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + (dataAtual.getDate() < 10 ? "0" : "") + dataAtual.getDate();
        }
    }
</script>
<style scoped>
input:invalid {
    border-color: red;
}
input:invalid + span {
    color: red;
}
.icon-button {
    font-size: 1.5rem;
    margin-left: 1rem;
    padding: 0 0.5rem;
}
.icon-button i {
    color: inherit;
    vertical-align: middle;
}
</style>
